import { FC } from "react";

interface Props {
  icon: string;
}

const NewsByIdIcon: FC<Props> = ({ icon }) => {
  return <img className="w-full h-full object-cover" src={icon} alt="" />;
};

export default NewsByIdIcon;
